@if (loading) {
  <div>
    <img alt="Loader" src="/images/loading.gif" [ngStyle]="{height: height, margin: 'auto', display: 'block'}">
  </div>
}
